// extracted by mini-css-extract-plugin
export default {"preview":"Preview_preview__CZh5t","prebiew__inner":"Preview_prebiew__inner__C1xbs","print":"Preview_print__5Spda","print__logo":"Preview_print__logo__ZUw4h"};